import React from 'react';
import { ReactComponent as Warning } from 'Icons/Warning.svg';

function LayersWarning({ errorText, style = null }) {
  return (
    <div
      id="layerswarning-wrapper"
      data-testid="layerswarning-wrapper"
      style={{ width: '100%', overflow: 'auto', ...style }}
      className="flex-y-center"
    >
      <Warning
        id="layerswarning-warning"
        data-testid="layerswarning-warning"
        style={{ width: '1.5rem', height: '1.375rem' }}
        fill="#F2C64B"
      />
      <label
        id="layerswarning-warning-msg"
        data-testid="layerswarning-warning-msg"
        style={{
          color: 'black',
          margin: '0 0 0 0.625rem',
          fontSize: '12px',
          lineHeight: '14px',
        }}
      >
        {errorText}
      </label>
    </div>
  );
}

export default LayersWarning;
